import { render, staticRenderFns } from "./about2.0.vue?vue&type=template&id=2d1a4dec&scoped=true"
import script from "./about2.0.vue?vue&type=script&lang=js"
export * from "./about2.0.vue?vue&type=script&lang=js"
import style0 from "./about2.0.vue?vue&type=style&index=0&id=2d1a4dec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a384144eff487845a016474d887108a3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a4dec",
  null
  
)

export default component.exports